import EditModalContent from './EditModalContent';

export default EditModalContent;
